<script context="module">
  import { TextField, SelectField } from "../../ui/form/fields";
  const ROLES = [
    { text: "Principal", value: "Principal" },
    { text: "Assistant Principal", value: "Assistant Principal" },
    { text: "Teacher", value: "Teacher" },
    { text: "Librarian", value: "Librarian" },
    { text: "Administrator", value: "Administrator" },
    { text: "Tech Director", value: "Tech Director" },
    { text: "Superintendant", value: "Superintendant" },
    { text: "Consultant", value: "Consultant" },
    { text: "Other", value: "Other" }
  ];
</script>

<script>
  export let key = null;
  export let name = null;
  export let required = null;
  export let autofocus = null;
  export let placeholder = null;

  let otherFieldEl;

  let showOther = false;

  function selectionChanged(event) {
    showOther = event.detail.option.value === "Other";
    if (showOther) {
      window.requestAnimationFrame(() => {
        otherFieldEl.focus();
      });
    }
  }
</script>

<div class="w-full">
  <SelectField {key} {name} {required} {autofocus} options={ROLES} {placeholder} on:changed={selectionChanged} />
  <div
    class="absolute mt-4 transition-all opacity-0 other-field"
    class:show-other={showOther}
    class:pointer-events-none={!showOther}
    class:pointer-events-auto={showOther}
  >
    <TextField
      bind:this={otherFieldEl}
      disabled={!showOther}
      key="otherPosition"
      name="Role"
      placeholder="Enter your role here"
      required={showOther}
    />
  </div>
</div>

<style>
  .other-field {
    transform: translateY(-100%);
  }
  .show-other {
    animation: moving 0.35s ease-in-out forwards;
    animation-delay: 0.1s;
  }
  @keyframes moving {
    50% {
      opacity: 0.1;
      position: relative;
    }
    100% {
      opacity: 1;
      transform: translateY(0);
      position: relative;
    }
  }
</style>
